import { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  TextField, Grid, Snackbar, Alert
} from "@mui/material";
import * as Yup from "yup";
import { initLinkService, Link } from "./linkService";
import { FormContainer, FormHeader, FormSection } from "../shared/FormLayout";

type Props = {
  link: Link | null;
}

export const EditLinkForm: FC<Props> = ({ link }) => {
  const linkService = initLinkService();
  const [token, setToken] = useState<string>("");
  const [successOpen, setSuccessOpen] = useState<boolean>(false);

  useEffect(() => {
    if (link) {
      setToken(link.token ?? "");
    }
  }, [link]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Navn er påkrevd"),
    url: Yup.string().required("URL er påkrevd"),
  });

  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      name: link?.name ?? "",
      url: link?.url ?? "",
    },
    resolver: yupResolver(validationSchema),
  });
  const { errors, isSubmitting } = formState;

  async function onSubmit({ name, url }: any) {
    const payload = { name, url, userProfileId: "" };
    if (!link) {
      await linkService.createLink(payload);
    } else {
      await linkService.updateLink(link.id, payload);
    }
    setSuccessOpen(true);
  }

  return (
    <FormContainer onSubmit={handleSubmit(onSubmit)}>
      <FormHeader section="Lenker" title={link?.name || "Ny lenke"} isSubmitting={isSubmitting} />

      <FormSection title="Lenke">
        <Grid item xs={12} md={4}>
          <TextField
            label="Navn"
            size="small"
            fullWidth
            {...register("name")}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <TextField
            label="URL"
            size="small"
            fullWidth
            {...register("url")}
            error={!!errors.url}
            helperText={errors.url?.message}
          />
        </Grid>
        {link && (
          <Grid item xs={12}>
            <TextField
              label="Token"
              size="small"
              fullWidth
              value={token}
              InputProps={{ readOnly: true }}
            />
          </Grid>
        )}
      </FormSection>

      <Snackbar open={successOpen} autoHideDuration={3000} onClose={() => setSuccessOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={() => setSuccessOpen(false)} severity="success" sx={{ width: '100%' }}>
          Lenken er {!link ? 'opprettet' : 'oppdatert'}.
        </Alert>
      </Snackbar>
    </FormContainer>
  );
};
